import classnames from 'classnames';
import React from 'react';

import { Tooltip } from 'src/components/common/tooltip/Tooltip';

interface Props {
  title?: string | React.ReactElement;
  className?: string;
  icon?: React.ReactElement | null;
  tooltipMessage?: string | null | undefined;
  children: React.ReactNode;
}

export const FieldSummarySection = ({
  title,
  children,
  className,
  icon,
  tooltipMessage,
}: Props) => (
  <div className={classnames(className)}>
    {title && (
      <Tooltip
        disabled={!tooltipMessage}
        label={tooltipMessage}
        placement="bottom-start"
      >
        <div className="text-sm font-semibold uppercase leading-6 text-secondary">
          {title}
          {icon}
        </div>
      </Tooltip>
    )}
    <div>{children}</div>
  </div>
);
